(function () {
  if (window.rfQtySyncInit) return;
  window.rfQtySyncInit = true;

  function fmt(cents, sample) {
    var m = sample.match(/123(\D)45/);
    if (m) return sample.replace(m[0], (cents / 100).toFixed(2).replace('.', m[1]));
    if (/123/.test(sample)) return sample.replace('123', String(Math.round(cents / 100)));
    return (cents / 100).toFixed(2);
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var section = root.closest('.shopify-section') || document;
    var pid = root.dataset.productId;
    var prices = {};
    try {
      prices = JSON.parse(section.querySelector('[data-rf-qty-variants="' + pid + '"]').textContent);
    } catch (e) { return; }
    var gels = parseInt(root.dataset.gels, 10) || 0;
    var sample = root.dataset.moneySample || '';
    var variantId = String(root.dataset.variantId || '');

    function qtyInput() {
      return section.querySelector('product-form-component input[name="quantity"]');
    }
    function idInput() {
      return section.querySelector('product-form-component input[name="id"]');
    }
    function tiers() {
      return section.querySelector('rf-volume-tiers');
    }
    function qty() {
      var q = parseInt(qtyInput() && qtyInput().value, 10);
      return q > 0 ? q : 1;
    }
    function pctFor(q) {
      var t = tiers();
      if (!t) return 0;
      var p2 = parseInt(t.dataset.pct2, 10) || 0;
      var p3 = parseInt(t.dataset.pct3, 10) || 0;
      return q >= 3 ? p3 : q === 2 ? p2 : 0;
    }
    /* Shopify cuts the discount per box to whole cents (rounded down). */
    function unitFor(price, pct) {
      if (!pct) return price;
      var t = tiers();
      if (t && t.dataset.round === 'true') return Math.round((price * (100 - pct)) / 500) * 5;
      return price - Math.floor((price * pct) / 100);
    }

    function setText(el, txt) {
      if (el.textContent !== txt) el.textContent = txt;
    }

    /* Remember the base numbers of each target once, so multiplying is
       always done from the original value, never from the last output. */
    function baseNumber(el) {
      if (el.dataset.rfBase == null) {
        var m = (el.textContent || '').match(/\d+([.,]\d+)?/);
        el.dataset.rfBase = m ? m[0].replace(',', '.') : '';
        el.dataset.rfTpl = el.textContent;
      }
      return parseFloat(el.dataset.rfBase);
    }

    function render() {
      var idEl = idInput();
      if (idEl && prices[String(idEl.value)]) variantId = String(idEl.value);
      var v = prices[variantId];
      if (!v) return;
      var q = qty();

      /* The price block shows the same total as the quantity tiles and the total box below
         them: the volume tiers work it out (Duo / Trio, Abo price, Mix 4). */
      var t = tiers();
      var total;
      var tierCompare = 0;
      if (t && typeof t.computeTier === 'function') {
        var tier = t.computeTier(v.price, q);
        total = tier.total;
        tierCompare = tier.compare || 0;
      } else {
        total = unitFor(v.price, pctFor(q)) * q;
      }
      var compareBase = v.compare && v.compare > v.price ? v.compare : v.price;
      var compare = Math.max(compareBase * q, tierCompare);
      var save = compare - total;

      /* Box count in front of the title: "3× " (hidden for a single box) */
      section.querySelectorAll('[data-rf-boxes]').forEach(function (el) {
        if (q > 1) {
          setText(el, q + '\u00d7 ');
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      /* Title suffix: "24 Gels" */
      section.querySelectorAll('.rf-quantity').forEach(function (el) {
        if (el.closest('[data-rf-static]')) return;
        var base = baseNumber(el);
        if (!base) return;
        var n = Math.round(base * q);
        var word = n === 1 ? root.dataset.tGel : root.dataset.tGels;
        setText(el, n + ' ' + word);
      });

      /* Box contents pills: "12× TRAIN" (only the visible variant span) */
      section.querySelectorAll('.rf-stats__v').forEach(function (group) {
        group.querySelectorAll('.rf-stats__i').forEach(function (el) {
          if (el.closest('[data-rf-static]')) return;
          var tpl = el.dataset.rfTpl || el.textContent;
          if (!/^\s*\d+\s*[×x]/.test(tpl)) return;
          var base = baseNumber(el);
          setText(el, tpl.replace(/^\s*\d+/, String(Math.round(base * q))));
        });
      });

      /* Price block */
      var priceGroup = section.querySelector('product-price .price');
      if (priceGroup) {
        var bdi = priceGroup.querySelector('bdi') || priceGroup;
        setText(bdi, fmt(total, sample));
      }
      /* Products without a compare-at price have no strikethrough in the
         theme markup, so one is added when a volume tier saves money. */
      var compareEl = section.querySelector('product-price .compare-at-price');
      if (!compareEl && save > 0 && priceGroup) {
        compareEl = document.createElement('span');
        compareEl.className = 'price-item__group price-item--regular compare-at-price';
        compareEl.innerHTML = '<bdi></bdi>';
        /* Same whitespace the theme markup has between price and compare-at. */
        priceGroup.insertAdjacentText('afterend', ' ');
        priceGroup.insertAdjacentElement('afterend', compareEl);
        priceGroup.insertAdjacentText('afterend', ' ');
      }
      if (compareEl) {
        var cb = compareEl.querySelector('bdi') || compareEl;
        if (save > 0) {
          setText(cb, fmt(compare, sample));
          compareEl.hidden = false;
          /* .price-item__group is display:inline-block, which beats [hidden]. */
          compareEl.style.display = '';
        } else {
          compareEl.hidden = true;
          compareEl.style.display = 'none';
        }
      }

      /* Save badge */
      section.querySelectorAll('.rf-save-badge').forEach(function (el) {
        if (save > 0) {
          setText(el, root.dataset.tSave + ' ' + fmt(save, sample));
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      /* Price per litre under the price (blocks/rf-pdp-header.liquid), for the chosen amount. */
      section.querySelectorAll('[data-rf-unit-l]').forEach(function (el) {
        var ml = parseFloat(el.dataset.ml) || 0;
        if (ml > 0) setText(el, fmt(Math.round((total * 1000) / (ml * q)), sample) + (el.dataset.suffix || ' / L'));
      });

      /* Per gel */
      section.querySelectorAll('.rf-price-per-gel[data-volume="false"] .rf-price-per-gel__amount').forEach(function (el) {
        if (gels > 0) setText(el, fmt(Math.round(total / (gels * q)), sample) + ' ');
      });
    }

    /* 24 Oct 2026: render in a microtask (was a 30 ms timeout): runs before the next paint, so the
       price never shows the theme's one-box value for a moment after a variant switch or a tile pick. */
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      Promise.resolve().then(function () {
        queued = false;
        render();
      });
    }

    section.addEventListener('input', schedule);
    section.addEventListener('change', schedule);
    section.addEventListener('click', function () { setTimeout(schedule, 0); setTimeout(schedule, 150); });
    document.addEventListener('shopify:product:select', function () { setTimeout(schedule, 0); setTimeout(schedule, 300); });
    document.addEventListener('variant:update', function () { setTimeout(schedule, 0); setTimeout(schedule, 300); });
    /* Abo switched on or off (snippets/rf-abo.liquid): the price follows. */
    document.addEventListener('rf:abo-change', schedule);
    /* The theme re-renders the price block on variant change, which
       resets the text. Writes only happen when the text differs, so
       observing our own changes cannot loop. */
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(section, { childList: true, subtree: true, characterData: true });
    }
    render();
  }

  function boot() {
    document.querySelectorAll('[data-rf-qty-sync]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

